import { forwardRef, CSSProperties } from 'react';

import { RouterLink } from 'src/routes/components';

import logoSrc from '../../assets/images/logo.png';

// ----------------------------------------------------------------------

export interface LogoProps {
  disabledLink?: boolean;
  style?: CSSProperties;
}

const Logo = forwardRef<HTMLDivElement, LogoProps>(
  ({ disabledLink = false, style, ...other }, ref) => {
    const logo = (
      <div
        ref={ref}
        style={{
          width: 40,
          height: 40,
          display: 'inline-flex',
          ...style,
        }}
        {...other}
      >
        <img src={logoSrc} />
      </div>
    );

    if (disabledLink) {
      return logo;
    }

    return (
      <RouterLink href="/" style={{ display: 'contents' }}>
        {logo}
      </RouterLink>
    );
  }
);

export default Logo;
